import useSWR from 'swr'
import { API_BASE_URL } from 'config/api'
import { fetcher, IError } from 'utils/fetchers'
import { ProductImage } from 'utils/imageUtils'

const apiUrl = `${API_BASE_URL}/products`

interface Attributes {
  appearance: string
  author: string
  pagesNumber: string
  publishYear: string
  translator: string
}

interface Comment {
  id: number
  customerFirstName: string
  customerLastName: string
  customerId: string
  rating: number
  comment: string
  createdAt: string
}

interface Book {
  attributes: Attributes
  price: number
  title: string
  vendor: string
  barcode: string
  compareAtPrice: number | null
  createdAt: Date
  description: string
  id: string
  images: ProductImage[]
  orderId: string | null
  ownerCellphone: string
  ownerId: string
  ownerLastName: string
  priceCurrency: string
  format?: string
  subject?: string
  cover?: string
  categoryTitle?: string
  reviews?: Comment[]
  averageRating?: number
  approvedReviewCount?: number
  reviewCount?: number
  comments?: Comment[]
  aboutTheAuthor?: string
  fromTheBackCover?: string
  extraDescription?: string
  someSentencesFromBook?: string[]
  partOfBook?: string
}

export function useFetchProduct(id: string | undefined) {
  const { data, error } = useSWR<Book, IError | null>(
    id ? `${apiUrl}/${id}` : null,
    fetcher,
  )
  return {
    book: data,
    isLoading: !error && !data,
    isError: !!error,
    error: error,
  }
}
